import React from 'react';

/**
 * Krok 3 kreatora - podsumowanie tego, co realnie trafilo do systemu.
 */
const Kafelek = ({ tytul, kolor, children }) => (
  <div style={{
    flex: '1 1 240px', minWidth: '220px',
    border: `1px solid ${kolor}`, borderLeft: `4px solid ${kolor}`,
    borderRadius: '6px', backgroundColor: 'var(--card-bg)', padding: '10px 12px'
  }}>
    <div style={{ fontSize: '10px', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.03em' }}>
      {tytul}
    </div>
    <div style={{ fontSize: '12px', color: 'var(--text)', marginTop: '4px', lineHeight: '1.6' }}>
      {children}
    </div>
  </div>
);

const WizardSummary = ({
  krok1Wynik, krok2Wynik, invoiceId,
  onOtworzFakture, onKolejnaFaktura, onOdNowa, onWrocDoListy
}) => {
  const przycisk = (kolor, wypelniony) => ({
    padding: '6px 12px', fontSize: '11px', borderRadius: '4px', cursor: 'pointer',
    border: `1px solid ${kolor}`,
    backgroundColor: wypelniony ? kolor : 'var(--card-bg)',
    color: wypelniony ? '#fff' : kolor,
    fontWeight: wypelniony ? '600' : '400'
  });

  const uzupelnienia = krok2Wynik?.wymagaUzupelnienia || 0;

  return (
    <div>
      <div style={{
        padding: '10px 12px', borderRadius: '6px', marginBottom: '12px',
        backgroundColor: 'var(--success-light)', border: '1px solid var(--success)',
        color: 'var(--success)', fontSize: '12px', fontWeight: '600'
      }}>
        {'✅'} Gotowe. Faktura zosta{'ł'}a zapisana w systemie.
      </div>

      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <Kafelek tytul="Krok 1 — cennik" kolor="var(--info)">
          {krok1Wynik ? (
            <>
              <div style={{ fontFamily: 'monospace', fontSize: '11px', color: 'var(--text-muted)' }}>
                {krok1Wynik.filename || '-'}
              </div>
              <div>Pozycji w pliku: <strong>{krok1Wynik.total || 0}</strong></div>
              <div>Utworzono: <strong>{krok1Wynik.created || 0}</strong></div>
              <div>Zaktualizowano: <strong>{krok1Wynik.updated || 0}</strong></div>
              <div>Odrzucono/pomini{'ę'}to: <strong>{krok1Wynik.skipped || 0}</strong></div>
            </>
          ) : (
            <span style={{ color: 'var(--text-muted)' }}>Krok pomini{'ę'}ty {'—'} cennik ju{'ż'} by{'ł'} w systemie.</span>
          )}
        </Kafelek>

        <Kafelek tytul="Krok 2 — faktura" kolor="var(--success)">
          <div style={{ fontWeight: '600' }}>{krok2Wynik?.numer || '-'}</div>
          <div>Pozycji: <strong>{krok2Wynik?.pozycje || 0}</strong></div>
          <div>Zmapowanych: <strong>{krok2Wynik?.zmapowane || 0}</strong></div>
          <div>
            Warto{'ść'} brutto:{' '}
            <strong>{parseFloat(krok2Wynik?.brutto || 0).toFixed(2)} z{'ł'}</strong>
          </div>
        </Kafelek>

        {uzupelnienia > 0 && (
          <Kafelek tytul="Wymaga uwagi" kolor="var(--danger)">
            <div style={{ color: 'var(--danger)', fontWeight: '600' }}>
              Pozycje wymagaj{'ą'}ce uzupe{'ł'}nienia: {uzupelnienia}
            </div>
            <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '4px' }}>
              Te pozycje nie wesz{'ł'}y na stan magazynowy ani do FIFO. Uzupe{'ł'}nij cennik i popraw fakur{'ę'} r{'ę'}cznie.
            </div>
          </Kafelek>
        )}
      </div>

      <div style={{ display: 'flex', gap: '8px', marginTop: '14px', flexWrap: 'wrap' }}>
        {invoiceId && onOtworzFakture && (
          <button onClick={onOtworzFakture} style={przycisk('var(--primary)', true)}>Otwórz fakturę</button>
        )}
        {onKolejnaFaktura && (
          <button onClick={onKolejnaFaktura} style={przycisk('var(--info)', false)}>
            Dodaj kolejn{'ą'} faktur{'ę'} od tego dostawcy
          </button>
        )}
        {onOdNowa && (
          <button onClick={onOdNowa} style={przycisk('var(--text-muted)', false)}>Zacznij od nowa</button>
        )}
        {onWrocDoListy && (
          <button onClick={onWrocDoListy} style={przycisk('var(--border)', false)}>
            <span style={{ color: 'var(--text-secondary)' }}>Wróć do listy</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default WizardSummary;
